import React from 'react'
import { injectIntl, FormattedMessage } from 'sb-react-intl'
import PropTypes from 'prop-types'
import cx from 'classnames'

import messages from './messages'
import s from './ActionButtons.scss'


const ActionButtons = (props) => {
  const {
    intl,
    id, isUseful, likeCount, dislikeCount, replyButtonActive,
    isReplyButtonVisible, isHelpfulButtonsActive,
    onVote, onReplyFormToggle,
    dataTestIds = {},
  } = props

  const thumbUpClassName = cx(s.action, s.thumbUp, {
    [s.active]: isUseful,
  })

  const thumbDownClassName = cx(s.action, s.thumbDown, {
    [s.active]: isUseful === false,
  })

  const replyButtonClassName = cx(s.action, {
    [s.active]: replyButtonActive,
  })

  const likeMessage     = intl.formatMessage(messages.like)
  const dislikeMessage  = intl.formatMessage(messages.dislike)

  const handleVote = (isLike) => () => {
    const value = isLike ? (isUseful ? null : true) : (isUseful === false ? null : false)

    onVote({ reviewId: id, isUseful: value })
  }

  return (
    <div>
      <button
        className={thumbUpClassName}
        type="button"
        disabled={!isHelpfulButtonsActive}
        aria-label={likeMessage}
        onClick={handleVote(true)}
      >
        <div className={s.icon} />
        <span data-testid={dataTestIds.likeButton}>
          {likeCount}
        </span>
      </button>
      <button
        className={thumbDownClassName}
        type="button"
        disabled={!isHelpfulButtonsActive}
        aria-label={dislikeMessage}
        onClick={handleVote(false)}
      >
        <div className={s.icon} />
        <span data-testid={dataTestIds.dislikeButton}>
          {dislikeCount}
        </span>
      </button>
      {
        isReplyButtonVisible && (
          <button
            type="button"
            className={replyButtonClassName}
            data-testid={dataTestIds.replyButton}
            onClick={() => onReplyFormToggle({ isShown: true })}
          >
            <FormattedMessage {...messages.reply} />
          </button>
        )
      }
    </div>
  )
}

ActionButtons.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  isUseful: PropTypes.bool,
  likeCount: PropTypes.number.isRequired,
  dislikeCount: PropTypes.number.isRequired,
  onVote: PropTypes.func,
  isReplyButtonVisible: PropTypes.bool,
  onReplyFormToggle: PropTypes.func,
  replyButtonActive: PropTypes.bool,
  isHelpfulButtonsActive: PropTypes.bool,
}

ActionButtons.defaultProps = {
  isUseful: false,
  isReplyButtonVisible: false,
  replyButtonActive: false,
  isHelpfulButtonsActive: true,
}


export default injectIntl(ActionButtons)
